// "/" — redirect to /app (where the dashboard lives) or to /sign-in if not authed.
// For now the auth check is naïve; once the AuthProvider lands we'll thread it.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/app" });
  },
});
